export const SUPPORT_CHAT_URL = 'https://chat.google.com/room/AAAA2b8Znbc?cls=7'
